import React from 'react';

export const AddReportTab = () => {
  return (
    <div className="py-8 text-center">
      <p className="text-blackBase font-semibold text-lg">
        🛠 Функционал в разработке. Скоро вы сможете создавать собственные кастомизированные отчеты на основе
        транскрипта. Оставайтесь с нами! ⏳
      </p>
    </div>
  );
};
